import { MetricTypeCodes } from '@kcftech/prometheus-client';

export type MetricTypeConfig = {
    metricType: MetricTypeCodes;
    selected: boolean;
    minAlarmBound?: number;
    maxAlarmBound?: number;
};

export type AlarmThresholdFormFields = Readonly<{
    start?: Date | null;
    end?: Date | null;
    warning?: number;
    criticalAlarm?: number;
    percentage?: number;
    points?: number;
    onlyToNotAlreadySetIndicators: boolean;
    groupIds: string[];
    indicatorTypes: MetricTypeConfig[];
}>;

export const INDICATOR_CHART_ITEMS = [
    {
        metricType: MetricTypeCodes.VibrationOverall,
        name: 'Overall Vibration',
        units: 'in/sec',
        defaultMin: 0.3,
        defaultMax: 1.5,
    },
    {
        metricType: MetricTypeCodes.VibrationOverallPeakAccel,
        name: 'Peak Acceleration',
        units: 'g',
        defaultMin: 6,
        defaultMax: 16,
    },
    {
        metricType: MetricTypeCodes.VibrationOverallPeak,
        name: 'Peak Velocity',
        units: 'in/sec',
        defaultMin: 0.3,
        defaultMax: 2,
    },
    {
        metricType: MetricTypeCodes.VibrationOverallRms,
        name: 'RMS Acceleration',
        units: 'in/sec',
        defaultMin: 5,
        defaultMax: 14,
    },
    {
        metricType: MetricTypeCodes.VibrationOverallRmsAccel,
        name: 'RMS Velocity',
        units: 'in/sec',
        defaultMin: 0.3,
        defaultMax: 2,
    },
    {
        metricType: MetricTypeCodes.Temperature,
        name: 'Temperature',
        units: '°F',
        defaultMin: 130,
        defaultMax: 167,
    },
] as const;
